export const UPDATE_FOLLOW_COUNT = "UPDATE_FOLLOW_COUNT";
